import { defineStore } from 'pinia';

export const useFinancial = defineStore({
  id: 'app-financial',
  state: () => ({
    isRefresh: false, // 是否重新刷新本次界面
    changeBranchInfo: {}, // 记录确认更换的银行卡信息
    otherBranchInfo: {}, // 记录其他银行卡信息银行
    addBranchInfo: {},
    shopMdCode: '', // 门店编号
    subjectType: '', // 主体类型
    shopName: '',
    accountType: '',
    headerShopMgCode: null,
    subjectInfo: null,
    operationMode: null,
  }),
});
